module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.8170d1e5.svg";